
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles.css'
import AlertPopup from './components/AlertPopup.vue';
import { Notification, Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$notify = Notification;

// 注册 Loading 全局组件
Vue.prototype.$loading = Loading.service;
Vue.config.productionTip = false
Vue.component('AlertPopup', AlertPopup); 
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
